export const FETCH_REPORTS = "FETCH_REPORTS";

// Report types
export const STUD_RPT = "students";
export const REQ_RPT = "requests";
export const FIN_RPT = "financial";
